import { FC } from 'react';

import DataTablePagination from 'modules/_shared/components/Tables/DataTablePagination';
import TableSkeleton from 'modules/_shared/components/Tables/TableSkeleton';

import { usePartnerOperations } from '../context/PartnerOperationsContext';
import PartnerOperationsTable from './PartnerOperationsTable';

const OperationsSectionBody: FC = () => {
  const { data, actions } = usePartnerOperations();

  const hasData = data.operations && data.operations.length > 0;
  const showPagination = hasData && data.totalOperations > data.rowsPerPage;

  return (
    <>
      {data.isLoading ? (
        <TableSkeleton
          rows={10}
          columns={5}
          showSubHeader={false}
          cardInner={false}
        />
      ) : (
        <div className="nk-block nk-block-lg">
          <PartnerOperationsTable />
        </div>
      )}

      {showPagination && (
        <DataTablePagination
          itemPerPage={data.rowsPerPage || 20}
          totalItems={data.totalOperations || 0}
          paginate={actions.handleChangePage}
          currentPage={data.page}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
          customItemPerPage={0}
          setRowsPerPage={() => {}}
          className="card-pagination-small border border-top-0 bg-lighter"
        />
      )}
    </>
  );
};

export default OperationsSectionBody;
